export default "__VITE_ASSET__RtZcRad$__"